import { useAutoAnimate } from "@formkit/auto-animate/react";
import { useNavigate } from "react-router";
import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { ILottery, useLottery } from "../../store/useLottery";
import dayjs from "dayjs";

export const LotteryTable = () => {
  /** Hooks */
  const { allLotteries, deleteLottery } = useLottery();
  const navigate = useNavigate();
  const [animationParent] = useAutoAnimate();

  const rows = allLotteries ?? [];

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Title
            </th>
            <th scope="col" className="px-2 min-w-32 sm:px-6 py-1 sm:py-4">
              Partner
            </th>
            <th scope="col" className="px-2 min-w-32 sm:px-6 py-1 sm:py-4">
              Prize title
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Start date
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Draw date
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Status
            </th>
            <th scope="col" className="px-2 min-w-36 sm:px-6 py-1 sm:py-4">
              Winners No.
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Participants
            </th>
            <th
              scope="col"
              className="hidden min-w-[148px] sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Tickets Given
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell min-w-48  px-2 sm:px-6 py-1 sm:py-4"
            >
              Vouchers Available
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Locations
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody ref={animationParent}>
          {rows?.length
            ? rows.map((lottery: ILottery) => (
                <tr
                  key={lottery?._id}
                  className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
                >
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap"
                  >
                    <div className="flex items-center gap-2">
                      <span>{lottery?.en_title}</span>
                      {!lottery?.numberOfVouchersAvailable &&
                      lottery?.status === "ACTIVE" ? (
                        <span
                          title="Hidden in the app until a voucher is assigned to this lottery"
                          className="inline-flex items-center rounded-full bg-red-100 text-red-700 text-xs font-medium px-2 py-0.5 whitespace-nowrap"
                        >
                          Needs voucher
                        </span>
                      ) : null}
                    </div>
                  </td>
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap"
                  >
                    {typeof lottery?.partner === "object" &&
                    lottery?.partner?.name
                      ? lottery.partner.name
                      : "-"}
                  </td>
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className="px-2 sm:px-6 py-1 sm:py-4"
                  >
                    {lottery?.en_prizeTitle}
                  </td>
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className="px-2 sm:px-6 py-1 sm:py-4"
                  >
                    {/* Optional field: an empty start date means the lottery
                        went live as soon as it was ACTIVE, so show a dash
                        rather than dayjs' "Invalid Date". */}
                    {lottery?.startsAt
                      ? dayjs(lottery.startsAt).format("DD/MM/YYYY HH:mm")
                      : "-"}
                  </td>
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className="px-2 sm:px-6 py-1 sm:py-4"
                  >
                    {dayjs(lottery?.drawDate).format("DD/MM/YYYY HH:mm")}
                  </td>
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className={`px-2 sm:px-6 py-1 sm:py-4 ${
                      lottery?.status === "PENDING"
                        ? "text-orange-700"
                        : lottery?.status === "ACTIVE"
                          ? "text-blue-700"
                          : "text-green-700"
                    }`}
                  >
                    {lottery?.status}
                  </td>
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className="px-2 sm:px-6 py-1 sm:py-4"
                  >
                    {/* @ts-ignore */}
                    {lottery?.winners?.length ?? "-"}
                  </td>
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                  >
                    {lottery?.numberOfParticipants ?? "-"}
                  </td>
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                  >
                    {lottery?.numberOfTickets ?? "-"}
                  </td>
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className={`hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4 ${
                      !lottery?.numberOfVouchersAvailable &&
                      lottery?.status === "ACTIVE"
                        ? "text-red-700 font-medium"
                        : ""
                    }`}
                  >
                    {lottery?.numberOfVouchersAvailable ?? "-"}
                  </td>
                  <td
                    onClick={() => navigate(`/edit-lottery/${lottery?._id}`)}
                    className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                  >
                    {lottery?.locationNames && lottery.locationNames.length > 0
                      ? lottery.locationNames.join(", ")
                      : "-"}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    <div className="flex items-center justify-end gap-3 sm:gap-4 cursor-pointer">
                      <EditIcon
                        onClick={() =>
                          navigate(`/edit-lottery/${lottery?._id}`)
                        }
                        className="flex-shrink-0"
                        style={{
                          width: "24px",
                          height: "24px",
                          minWidth: "24px",
                          minHeight: "24px",
                        }}
                      />
                      <img
                        alt="copy-icon"
                        onClick={() =>
                          navigate(`/copy-lottery/${lottery?._id}`)
                        }
                        src={require("../../assets/icons/tables/copy-icon.png")}
                        className="w-6 h-6 flex-shrink-0 cursor-pointer"
                      />
                      <TrashIcon
                        onClick={() => {
                          const confirmDelete = window.confirm(
                            "Are you sure you want to delete this Lottery?"
                          );
                          if (confirmDelete) {
                            deleteLottery(lottery?._id as string);
                          }
                        }}
                        className="flex-shrink-0"
                        style={{
                          width: "27px",
                          height: "27px",
                          minWidth: "27px",
                          minHeight: "27px",
                        }}
                      />
                    </div>
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
};
